import { supabase } from './supabase'

export type IssueType = 'ui_error' | 'payment_failure' | 'api_error' | 'performance' | 'other'
export type IssueSeverity = 'low' | 'medium' | 'high' | 'critical'

export interface ReportIssueParams {
    profile_id?: string
    type: IssueType
    severity: IssueSeverity
    message: string
    metadata?: Record<string, any>
}

/**
 * Logs an issue to the Supabase 'issue_logs' table.
 * Used for both automatic error tracking and manual user bug reports.
 */
export async function reportIssue({
    profile_id,
    type,
    severity,
    message,
    metadata = {},
}: ReportIssueParams): Promise<{ error: string | null }> {
    try {
        const { error } = await supabase.from('issue_logs').insert({
            profile_id,
            type,
            severity,
            message,
            page_url: typeof window !== 'undefined' ? window.location.href : null,
            metadata: {
                ...metadata,
                userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
                timestamp: new Date().toISOString(),
            },
        })

        if (error) {
            console.error('[MoniFlow] Failed to log issue:', error)
            return { error: error.message }
        }

        return { error: null }
    } catch (err) {
        const msg = err instanceof Error ? err.message : String(err)
        console.error('[MoniFlow] Error in reportIssue:', msg)
        return { error: msg }
    }
}
